



















import { defineComponent } from '@vue/composition-api';
import BaseTreeStructure from './_base-tree-structure.vue';

export default defineComponent({
  name: 'BaseTree',
  components: {
    BaseTreeStructure,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    childrenKey: {
      type: String,
      required: true,
    },
  },
});
